import './App.css';
import AppRoute from './components/AppRoute';

function App() {
  return (
    <AppRoute />
  );
}

export default App;
